import React from 'react';
import asyncComponent from '../../../util/asyncComponent';

import PrivateRoute from './PrivateRoute';
import { Route, Switch } from 'react-router-dom';

const Digital = asyncComponent(() => import('../digital'));

const Conversas = asyncComponent(() =>
  import('../digital/agente-virtual/chat')
);

const AgenteVirtualParametrizacoes = asyncComponent(() =>
  import('../digital/agente-virtual')
);
const AgenteVirtualMailling = asyncComponent(() =>
  import('../digital/agente-virtual/mailling')
);
const AgenteVirtualPainel = asyncComponent(() =>
  import('../digital/agente-virtual/painel')
);

const AgenteVirtualRobos = asyncComponent(() =>
  import('../digital/agente-virtual/agentes')
);
const AgenteVirtualNumeros = asyncComponent(() =>
  import('../digital/agente-virtual/numeros')
);
const TemplatesMensagem = asyncComponent(() =>
  import('../digital/agente-virtual/templates')
);

const AcessosPortalDeNegociacoes = asyncComponent(() =>
  import('../digital/portal-de-negociacao/ListaHistoricoAcessos')
);
const ConfiguracoesPortalDeNegociacoes = asyncComponent(() =>
  import('../digital/portal-de-negociacao/ListaConfiguracoes')
);
const CustomizacaoPortalDeNegociacoes = asyncComponent(() =>
  import('../digital/portal-de-negociacao/customizacao/CustomizacaoPortal')
);
const DominioPortalDeNegociacoes = asyncComponent(() =>
  import('../digital/portal-de-negociacao/dominio')
);

const AcessosPortalDoCredor = asyncComponent(() =>
  import('../backoffice/HistoricoDeAcesso/ListarHistoricoDeAcesso')
);
const CustomizacaoPortalDoCredor = asyncComponent(() =>
  import('../digital/portal-do-credor/CustomizacaoPortal')
);
const DominioPortalDoCredor = asyncComponent(() =>
  import('../digital/portal-do-credor/dominio')
);
const NivelAcessoPortalDoCredor = asyncComponent(() =>
  import('../digital/portal-do-credor/NivelAcessoPortalDoCredor')
);

const ReguaDeCobranca = asyncComponent(() =>
  import('../digital/regua-de-cobranca/ListaRegua')
);
const ReguaDeCobrancaAcoes = asyncComponent(() =>
  import('../digital/regua-de-cobranca/DetalharRegua')
);
const ListarEventosRegua = asyncComponent(() =>
  import('../digital/regua-de-cobranca/eventos')
);

export default function DigitalRoutes({ match }) {
  return (
    <>
      <Switch>
        <PrivateRoute
          path={`${match.url}/digital/conversas`}
          component={Conversas}
          codigo="digital.conversas"
        />

        <PrivateRoute
          path={`${match.url}/digital/whatsapp/numeros`}
          component={AgenteVirtualNumeros}
          codigo="digital_agente_virtual"
        />
        <PrivateRoute
          path={`${match.url}/digital/whatsapp/templates`}
          component={TemplatesMensagem}
          codigo="digital_agente_virtual"
        />

        <PrivateRoute
          path={`${match.url}/digital/agente-virtual/config`}
          component={AgenteVirtualParametrizacoes}
          codigo="digital_agente_virtual"
        />
        <PrivateRoute
          path={`${match.url}/digital/agente-virtual/mailling`}
          component={AgenteVirtualMailling}
          codigo="digital_agente_virtual"
        />
        <PrivateRoute
          path={`${match.url}/digital/agente-virtual/agentes`}
          component={AgenteVirtualRobos}
          codigo="digital_agente_virtual"
        />
        <PrivateRoute
          path={`${match.url}/digital/agente-virtual/painel`}
          component={AgenteVirtualPainel}
          codigo="digital_agente_virtual"
        />

        <PrivateRoute
          path={`${match.url}/digital/portal/acessos`}
          component={AcessosPortalDeNegociacoes}
          codigo="digital_portal_neg"
        />
        <PrivateRoute
          path={`${match.url}/digital/portal/customizacao`}
          component={CustomizacaoPortalDeNegociacoes}
          codigo="digital_portal_neg"
        />
        <PrivateRoute
          path={`${match.url}/digital/portal/config`}
          component={ConfiguracoesPortalDeNegociacoes}
          codigo="digital_portal_neg"
        />
        <PrivateRoute
          path={`${match.url}/digital/portal/dominio`}
          component={DominioPortalDeNegociacoes}
          codigo="digital_portal_neg"
        />

        <PrivateRoute
          path={`${match.url}/digital/portal-credor/acessos`}
          component={AcessosPortalDoCredor}
          codigo="digital_portal_credor"
        />
        <PrivateRoute
          path={`${match.url}/digital/portal-credor/customizacao`}
          component={CustomizacaoPortalDoCredor}
          codigo="digital_portal_credor"
        />
        <PrivateRoute
          path={`${match.url}/digital/portal-credor/dominio`}
          component={DominioPortalDoCredor}
          codigo="digital_portal_credor"
        />
        <PrivateRoute
          path={`${match.url}/digital/portal-credor/nivel-acesso`}
          component={NivelAcessoPortalDoCredor}
          codigo="digital_portal_credor"
        />

        <PrivateRoute
          path={`${match.url}/digital/regua-de-cobranca/acoes/:id`}
          component={ReguaDeCobrancaAcoes}
          codigo="digital_regua_cobranca"
        />
        <PrivateRoute
          path={`${match.url}/digital/regua-de-cobranca/config`}
          component={ReguaDeCobranca}
          codigo="digital_regua_cobranca"
        />
        <PrivateRoute
          path={`${match.url}/digital/regua-de-cobranca/eventos`}
          component={ListarEventosRegua}
          codigo="digital_regua_cobranca"
        />

        <Route path={`${match.url}/digital/inicio`} component={Digital} />
        <Route exact path={`${match.url}/digital`} component={Digital} />
      </Switch>
    </>
  );
}
